import Button, { ButtonProps } from './button';
import translate from '../functions/translate';

interface CancelButtonProps {
    onClick: () => void
    mfaAnalyticsHeading?: string
}

const CancelButton = (props: CancelButtonProps) => {
    let mfaAnaltyicsData: ButtonProps['mfaAnalyticsData'];
    if (props.mfaAnalyticsHeading) {
        mfaAnaltyicsData = {
            text: translate('cancel'),
            parentComponentHeading: props.mfaAnalyticsHeading
        }
    }

    return <>
        <Button
            onClick={props.onClick}
            mfaAnalyticsData={mfaAnaltyicsData}
        >
            {translate('cancel')}
        </Button>
    </>;
}

export default CancelButton;
